import vHeroSlider from "./v-hero-slider.vue";
import vPaginationDots from "./pagination-dots/v-pagination-dots.vue";

export default Vue => {
  Vue.component("v-hero-slider", vHeroSlider);
  Vue.component("v-pagination-dots", vPaginationDots);
};
